import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-components-ReactFlow-FindBar', [
  'bar',
  'drag',
  'input',
  'count',
  'previous',
  'next',
  'close',
]);
